import { render, staticRenderFns } from "./HighlightText.vue?vue&type=template&id=26474dff&scoped=true"
import script from "./HighlightText.vue?vue&type=script&lang=js"
export * from "./HighlightText.vue?vue&type=script&lang=js"
import style0 from "./HighlightText.vue?vue&type=style&index=0&id=26474dff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26474dff",
  null
  
)

export default component.exports